var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("validation-observer", { ref: "form", attrs: { novalidate: "" } }, [
        _c(
          "div",
          [
            _c("section-title", {
              attrs: {
                "container-class": "tag-badge-main-info mt-4 mb-4",
                content:
                  "I. Datos de Identificación del Participante (Parte B)",
                icon: "fas fa-clipboard-list-check"
              }
            }),
            _c(
              "div",
              [
                _c("section-title", {
                  staticClass: "mt-3",
                  attrs: {
                    content: "Propósito de la Evaluación Vocacional",
                    "has-line": ""
                  }
                }),
                _vm._l(_vm.purposeOfEvaluationOptions, function(item) {
                  return _c("check-box", {
                    key: item.id,
                    class: _vm.isReadOnly
                      ? "row-check disabled-check"
                      : "row-check",
                    attrs: { disabled: _vm.isReadOnly, text: item.name },
                    model: {
                      value: item.checked,
                      callback: function($$v) {
                        _vm.$set(item, "checked", $$v)
                      },
                      expression: "item.checked"
                    }
                  })
                }),
                _c("validation-provider", {
                  attrs: {
                    name: `type-${_vm.purposeOfEvaluationId}-options`,
                    rules: _vm.hasOptionCheck(_vm.purposeOfEvaluationId)
                      ? ""
                      : "required"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          errors[0]
                            ? _c("error", {
                                staticClass: "pt-2",
                                attrs: {
                                  message:
                                    "Al menos un Propósito de la Evaluación Vocacional es requerido.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              2
            ),
            _c(
              "div",
              [
                _c("section-title", {
                  staticClass: "mt-3",
                  attrs: { content: "Análisis de Expediente", "has-line": "" }
                }),
                !_vm.isReadOnly
                  ? _c("div", [
                      _c("label", [
                        _vm._v("Seleccione Análisis de Expediente:")
                      ]),
                      _c("div", { staticClass: "row mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("custom-drop-down", {
                              class: {
                                "was-Invalidated":
                                  !_vm.currentRecord &&
                                  _vm.currentRecordValidated
                              },
                              attrs: {
                                id: "record",
                                clearable: "",
                                disabled: _vm.isReadOnly,
                                fieldkey: "id",
                                fieldname: "name",
                                options: _vm.availableRecords,
                                placeholder: "Seleccione"
                              },
                              model: {
                                value: _vm.currentRecord,
                                callback: function($$v) {
                                  _vm.currentRecord = $$v
                                },
                                expression: "currentRecord"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "student-search-alert-error d-flex items-align-center no-border"
                              },
                              [
                                !_vm.currentRecord && _vm.currentRecordValidated
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-100 text-left text-danger"
                                      },
                                      [
                                        _c("div", { staticClass: "d-inline" }, [
                                          _c("em", {
                                            staticClass: "fa fa-times-circle"
                                          })
                                        ]),
                                        _c(
                                          "p",
                                          { staticClass: "text-left d-inline" },
                                          [_vm._v(" El campo es requerido ")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm.isRecordOther
                          ? _c(
                              "div",
                              { staticClass: "col-3" },
                              [
                                _c("custom-input", {
                                  class: {
                                    "was-Invalidated":
                                      !_vm.currentRecordOther &&
                                      _vm.currentRecordValidated
                                  },
                                  attrs: {
                                    id: "currentRecordOther",
                                    disabled: _vm.isReadOnly
                                  },
                                  model: {
                                    value: _vm.currentRecordOther,
                                    callback: function($$v) {
                                      _vm.currentRecordOther = $$v
                                    },
                                    expression: "currentRecordOther"
                                  }
                                }),
                                !_vm.currentRecordOther &&
                                _vm.currentRecordValidated
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-100 text-left text-danger"
                                      },
                                      [
                                        _c("div", { staticClass: "d-inline" }, [
                                          _c("em", {
                                            staticClass: "fa fa-times-circle"
                                          })
                                        ]),
                                        _c(
                                          "p",
                                          { staticClass: "text-left d-inline" },
                                          [_vm._v(" El campo es requerido ")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("action-button", {
                              attrs: {
                                disabled: _vm.isReadOnly,
                                i: "fas fa-plus",
                                text: "Añadir",
                                variant: "success mr-3 px-3"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addRecord()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _c("label", [_vm._v("Seleccionados:")]),
                _c("validation-provider", {
                  attrs: {
                    name: "records",
                    rules: _vm.selectedRecords.length > 0 ? "" : "required"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "mb-3" },
                            [
                              _c("chips-selection", {
                                attrs: {
                                  "chips-config": [],
                                  disabled: _vm.isReadOnly,
                                  items: _vm.selectedRecords
                                },
                                on: { remove: _vm.removeRecord }
                              })
                            ],
                            1
                          ),
                          errors[0]
                            ? _c("error", {
                                attrs: {
                                  message:
                                    "Al menos un Análisis de Expediente es requerido.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              [
                _c("section-title", {
                  staticClass: "mt-3",
                  attrs: {
                    content: "Cursos de Exploración Ocupacional ",
                    "has-line": ""
                  }
                }),
                _c("label", { staticClass: "data-name" }, [
                  _vm._v(
                    " ¿El estudiante ha tomado algún curso de Exploración Ocupacional (CTEX/EDES)?: "
                  )
                ]),
                !_vm.isReadOnly
                  ? _c("custom-radio", {
                      staticClass: "row",
                      attrs: {
                        disabled: _vm.isReadOnly,
                        "is-inline": "",
                        name: "hasTakenCourseOccupationalExploration",
                        options: _vm.yesNotOptions
                      },
                      model: {
                        value: _vm.model.hasTakenCourseOccupationalExploration,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model,
                            "hasTakenCourseOccupationalExploration",
                            $$v
                          )
                        },
                        expression:
                          "model.hasTakenCourseOccupationalExploration"
                      }
                    })
                  : _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("boolText")(
                              _vm.model.hasTakenCourseOccupationalExploration
                            )
                          ) +
                          " "
                      )
                    ]),
                _vm.model.hasTakenCourseOccupationalExploration
                  ? _c(
                      "div",
                      [
                        !_vm.isReadOnly && _vm.canAddCourse
                          ? _c("div", [
                              _c("label", [
                                _vm._v("Seleccione Análisis de Expediente:")
                              ]),
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("custom-drop-down", {
                                      class: {
                                        "was-Invalidated":
                                          !_vm.currentCourse &&
                                          _vm.currentCourseValidated
                                      },
                                      attrs: {
                                        id: "course",
                                        clearable: "",
                                        disabled:
                                          _vm.isReadOnly ||
                                          _vm.isInPrivateSchool,
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.availableCourse,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value: _vm.currentCourse,
                                        callback: function($$v) {
                                          _vm.currentCourse = $$v
                                        },
                                        expression: "currentCourse"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "student-search-alert-error d-flex items-align-center no-border"
                                      },
                                      [
                                        !_vm.currentCourse &&
                                        _vm.currentCourseValidated
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "w-100 text-left text-danger"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-inline" },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "fa fa-times-circle"
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-left d-inline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " El campo es requerido "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm.isCourseOther
                                  ? _c(
                                      "div",
                                      { staticClass: "col-3" },
                                      [
                                        _c("custom-input", {
                                          class: {
                                            "was-Invalidated":
                                              !_vm.currentCourseOther &&
                                              _vm.currentCourseValidated
                                          },
                                          attrs: {
                                            id: "currentCourseOther",
                                            disabled: _vm.isReadOnly
                                          },
                                          model: {
                                            value: _vm.currentCourseOther,
                                            callback: function($$v) {
                                              _vm.currentCourseOther = $$v
                                            },
                                            expression: "currentCourseOther"
                                          }
                                        }),
                                        !_vm.currentCourseOther &&
                                        _vm.currentCourseValidated
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "w-100 text-left text-danger"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-inline" },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "fa fa-times-circle"
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-left d-inline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " El campo es requerido "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("action-button", {
                                      attrs: {
                                        disabled: _vm.isReadOnly,
                                        i: "fas fa-plus",
                                        text: "Añadir",
                                        variant: "success mr-3 px-3"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.addCourse()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e(),
                        _c("label", [_vm._v("Seleccionados:")]),
                        _c("validation-provider", {
                          attrs: {
                            name: "courses",
                            rules:
                              _vm.selectedCourses.length > 0 ? "" : "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "mb-3" },
                                      [
                                        _c("chips-selection", {
                                          attrs: {
                                            "chips-config": [],
                                            disabled: _vm.isReadOnly,
                                            items: _vm.selectedCourses
                                          },
                                          on: { remove: _vm.removeRecord }
                                        })
                                      ],
                                      1
                                    ),
                                    errors[0]
                                      ? _c("error", {
                                          attrs: {
                                            message:
                                              "Al menos un Análisis de Expediente es requerido.",
                                            variant: "no-border"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4112377900
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              [
                _c("section-title", {
                  staticClass: "mt-3",
                  attrs: {
                    content: "Métodos de Evaluación Utilizados",
                    "has-line": ""
                  }
                }),
                _c("validation-provider", {
                  attrs: {
                    name: "type-options",
                    rules: _vm.hasOptionCheck(_vm.purposeOfEvaluationId, true)
                      ? ""
                      : "required"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          errors[0]
                            ? _c("error", {
                                staticClass: "pb-3",
                                attrs: {
                                  message:
                                    "Al menos un Métodos de Evaluación es requerido.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e(),
                          _vm._l(_vm.types, function(type, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "mb-4" },
                              [
                                _c("options-panel", {
                                  attrs: {
                                    data: _vm.options(type),
                                    "is-read-only": _vm.isReadOnly,
                                    "is-vertical": "",
                                    type: type
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          errors[0]
                            ? _c("error", {
                                attrs: {
                                  message:
                                    "Al menos un Métodos de Evaluación es requerido.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }